import React from 'react';
import { useLazyLoading } from '../_common';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

interface JobManagementTableProps {
    jobsList: any[];
    columnsJobManagement: any[];
    isLoading: boolean;
    isEndOfResults: boolean;
    onLoadMore: () => void;
}

const JobManagementTable = ({
    jobsList,
    columnsJobManagement,
    isLoading,
    isEndOfResults,
    onLoadMore,
}: JobManagementTableProps): React.ReactElement => {
    const { handleScroll } = useLazyLoading('jobList', isLoading, isEndOfResults, onLoadMore);
    const gridRef = React.useRef<AgGridReact<any>>(null);

    const defaultColDef = React.useMemo<any>(() => {
        return {
            flex: 1,
            resizable: false,
            filter: true,
            wrapText: true,
            enableRangeSelection: true,
            autoHeight: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center"
            })
        };
    }, []);

    return (
        <div
            id="jobList"
            className="LoadManagement-List JobManagementTable"
            onScroll={handleScroll}
        >
            <div className="ag-theme-quartz">
                <AgGridReact
                    ref={gridRef}
                    rowData={jobsList}
                    columnDefs={columnsJobManagement}
                    suppressMenuHide={true}
                    defaultColDef={defaultColDef}
                    suppressCellFocus
                    suppressRowClickSelection
                    animateRows={false}
                    headerHeight={50}
                />
            </div>
        </div>
    );
};

export default JobManagementTable;
